import { Dialog, DialogContent, Grid, Slide } from "@mui/material";
import React, { forwardRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setPageDialog } from "../../../../app/slices/jomla/safeSlice";
import JSafeTransferTable from "./home/table";
import JSafeTransferHeader from "./home/header";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const JSafeTransfer = () => {
  const _JSafeTransfer = useSelector((state) => state.jSafe);

  const dispatch = useDispatch();

  const handleDialog = () => {
    dispatch(setPageDialog());
  };

  return (
    <Dialog
      open={_JSafeTransfer.dialog}
      TransitionComponent={Transition}
      keepMounted
      fullWidth={true}
      dir="rtl"
      onClose={() => {
        handleDialog();
      }}
      maxWidth="xl"
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <JSafeTransferHeader />
          </Grid>
          <Grid item xs={12}>
            <JSafeTransferTable />
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default JSafeTransfer;
